















import {Component, Prop, Vue} from 'vue-property-decorator'
import DataSpecsFormItems from "@/component/Thing/data-specs-form-items.vue";
import {ParamBindProxy} from "@/module/thing/ParamProxy"
import {cannotFindPropErr} from "@/module/thing/TmodelError";
import {Property} from "@/model/ThingModel";
import ArrayUtil from "tools-ts/src/util/ArrayUtil";
import thingModelModule from '@/store/module/ThingModelModule';

@Component({
  components: {
    DataSpecsFormItems
  },
})
export default class ParamBindProxyFormItems extends Vue {
  @Prop() private paramProxy!: ParamBindProxy

  private thingModelModule = thingModelModule

  private propMap: Map<string, Property> =
      ArrayUtil.groupById(
          thingModelModule.thingModel.properties,
          it => it.identifier
      )

  private changeBindProp(identifier: string) {
    const prop = this.propMap.get(identifier)
        ?? cannotFindPropErr(identifier)
    const proxy = ParamBindProxy.of(prop)
    this.$emit('update:paramProxy', proxy)
  }
}
